<div>{{title}}</div>

<div cdkDropList (cdkDropListDropped)="onCdkDropListDropped($event)" class="drag-drop-group">
    <ng-container *ngFor="let item of items">
        <div cdkDrag class="drag-drop-group-item">
            {{getDisplay(item)}}
        </div>
    </ng-container>
</div>